export const frontmatter = {
    "draft": true,
    "title": "SDKs oficiales",
    "sidebar_group": "referencia",
    "sidebar_label": "SDKs",
    "sidebar_order": 3
}

export const toc = []